module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"cs":{"CookieConsent":{"button":"V pořádku","heading":"Tento web používá k poskytování služeb, personalizaci reklam a analýze návštěvnosti soubory cookie.{newLine}Používáním tohoto webu s tím souhlasíte.","link":"Další informace"}}}')
  delete Component.options._Ctor
}
